import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import DisplayImage from '../display-image';
import {colors, fontFamily, fontSize, fontWeight, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.flexible-card-main-wrapper`. 768px mirrors the
// removed `tabScreen` mixin (max-width: 768px).
const sxCardMainWrapper = {
    marginTop: spacing[32],
    '@media (max-width: 768px)': {
        marginTop: 0
    }
};

// Migrated from globals.scss `.flexible-grid-item` (+ tabScreen/mobileScreen
// overrides — 768px and 430px respectively).
const sxGridItem = {
    '@media (max-width: 768px)': {
        marginTop: '50px' // no exact spacing-token match
    },
    '@media (max-width: 430px)': {
        '&:first-child': {
            marginTop: spacing[24]
        }
    }
};

// Migrated from globals.scss `.flexible-card-wrapper` (+ smallmobileScreen img
// override, max-width: 380px). box-shadow kept literal — no shadows.* token
// reproduces this two-layer value.
const sxCardWrapper = {
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    padding: spacing[24],
    textAlign: 'center',
    height: '100%',
    position: 'relative',
    paddingTop: spacing[60],
    backgroundColor: colors.background.default,
    '& span': {
        fontWeight: fontWeight.bold
    },
    '& h4': {
        fontFamily: fontFamily.heading,
        fontWeight: fontWeight.semibold,
        fontSize: fontSize[20]
    },
    '& p': {
        fontFamily: fontFamily.body,
        fontSize: fontSize[16]
    },
    '& img': {
        position: 'absolute',
        top: '-50px', // no exact spacing-token match
        left: '38%'
    },
    '@media (max-width: 380px)': {
        '& img': {
            left: '34%'
        }
    }
};

const sxCardSubheading = {
    padding: `${spacing[16]} 0`
};

const sxCardSubpointsWrapper = {
    '& p': {
        display: 'flex',
        alignItems: 'center',
        gap: spacing[8],
        marginBottom: spacing[12]
    }
};

const FlexibleCard = (props: any) => {
    const {heading, subheading, contentData} = props;

    return (
        <Box>
            <MUIContainer>
                <Box className="spectrum-header-wrapper solutions">
                    <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                        {heading}
                    </Typography>
                    <Box className={subheading !== undefined ? 'divder-wrapper' : ''}>
                        <hr className="divider-line divider-line-left" />
                    </Box>
                    {subheading && (
                        <Box className="sub-heading-box">
                            <Typography className="spectrum-sub-heading bottom-space color-black spacing platform-sub-heading text-align-left">
                                {subheading ? parse(subheading) : ''}
                            </Typography>
                        </Box>
                    )}
                </Box>
                <Grid container spacing={3} sx={sxCardMainWrapper}>
                    {contentData?.map((item: any, index: number) => (
                        <Grid item md={4} sm={6} xs={12} key={index + 1} sx={sxGridItem}>
                            <Box sx={sxCardWrapper}>
                                <DisplayImage alt={item.header} src={item.src} />
                                <Typography component="h4">{item.header}</Typography>
                                <Typography component="p" sx={sxCardSubheading}>
                                    {item.subheader ? parse(item.subheader) : ''}
                                </Typography>
                                <Box textAlign="left" sx={sxCardSubpointsWrapper}>
                                    {item.subPoints?.map((subItem: any, subIndex: number) => (
                                        <Typography component="p" key={subIndex + 1}>
                                            <span>●</span> {subItem}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(FlexibleCard);
